import { Card, CardBody, CardSubtitle, CardTitle, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import React from "react";
import { Link } from "react-router-dom";
import { PermissionLink } from './permission/PermissionLink';

const ComponentCard = ({ children, title, subtitle, buttonLabel, buttonLink, buttonOnClick, buttonPermission, secondaryButtonLabel, secondaryButtonLink, secondaryButtonOnClick }) => {
  const renderButton = () => {
    if (!buttonLabel) return null;

    if (buttonLink) {
      return buttonPermission ? (
          <PermissionLink
              permission={buttonPermission}
              className="btn btn-primary btn-xs id-primary"
              to={buttonLink}
              title={buttonLabel}
          >
            {buttonLabel}
          </PermissionLink>
      ) : (
          <Link className="btn btn-primary btn-xs id-primary" to={buttonLink} title={buttonLabel}>
            {buttonLabel}
          </Link>
      );
    }

    if (buttonOnClick) {
      return buttonPermission ? (
          <PermissionLink
              permission={buttonPermission}
              className="btn btn-primary btn-xs id-primary"
              onClick={buttonOnClick}
              title={buttonLabel}
          >
            {buttonLabel}
          </PermissionLink>
      ) : (
          <Button color="primary" size="xs" className="id-primary" onClick={buttonOnClick} title={buttonLabel}>
            {buttonLabel}
          </Button>
      );
    }

    return null;
  };

  const renderSecondaryButton = () => {
    if (!secondaryButtonLabel) return null;

    if (secondaryButtonLink) {
      return (
        <Link className="btn btn-outline-secondary btn-xs me-2 id-secondary" to={secondaryButtonLink}>
          {secondaryButtonLabel}
        </Link>
      );
    }

    if (secondaryButtonOnClick) {
      return (
        <Button color="secondary" outline size="xs" className="me-2 id-secondary" onClick={secondaryButtonOnClick}>
          {secondaryButtonLabel}
        </Button>
      );
    }

    return null;
  };

  return (
      <Card>
        <CardTitle>
          {title ? (
              <h4 className="card-header d-flex justify-content-between align-items-center">
                {title}
                <div>
                  {renderSecondaryButton()}
                  {renderButton()}
                </div>
              </h4>
          ) : null}
        </CardTitle>
        <CardBody className="p-3">
          <CardSubtitle className="text-muted mb-3 display-none">{subtitle || ''}</CardSubtitle>
          <div>{children}</div>
        </CardBody>
      </Card>
  );
};

ComponentCard.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  buttonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonLink: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonPermission: PropTypes.string,
  secondaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryButtonLink: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
  subtitle: PropTypes.node
};

export default ComponentCard;
